import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation,Output,EventEmitter} from '@angular/core';
import {Store} from '@ngrx/store';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import {ProductFullSolrDTO, ProductSolrDTO} from '@signature-it/ngx-catalogue/models';
import { CartActions } from '@signature-it/ngx-catalogue/store/actions';
import {getAddToCartError, getAddToCartOpenModal, getUpdatedCartSuccess} from '@signature-it/ngx-catalogue/store/selectors';
import { SolrProductService, ProductPageService_Generic, QuickPadService_Generic } from '@signature-it/ngx-catalogue/services';
import {Observable, Subscription} from "rxjs";
import { AddToSuccessModalComponentGeneric } from '@signature-it/ngx-catalogue/components/success-modal';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";



interface IAddToCartData {
    product_id: any;
    quantity: number;
    cngData?: any;
    cng_product_id?: number;
    price_bom?: number;
    product_bom?: number;
}

@Component({
    selector: 'add-to-cart',
    templateUrl: './add-to-cart.component.html',
    styleUrls: ['./add-to-cart.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddToCartComponent implements OnChanges, OnInit {

    static readonly BLOCK_ADD_TO_CART_ERROR = 'The product type in the basket is different';

    @Input() product: ProductSolrDTO;
    @Input() quickBuy: boolean = false;
    @Input() productId: number;
    @Input() fixedLotMultiplier: number;
    @Input() minQty: number = 0;
    @Input() maxQty: number;
    @Input() mode: string = 'center';
    @Input() addToCartText: string = 'Add to Cart';
    @Input() redirectText: string = 'View Shopping Cart';
    @Input() continueText: string = 'Continue Shopping';
    @Input() addToQuickPad: boolean = false;
    @Input() qtyInStock: number;
    @Input() productSku: string;
    @Output() quantityChange: EventEmitter<number> = new EventEmitter<number>();
    quantity: number = 0;
    unCommerceApp: boolean = GenericConfig.unCommerceApp || false;
    data: any;
    addToCartError$: Observable<string>;
    updatedCartSuccess$: Observable<boolean>;
    subscriptions: Subscription;
    openModalSub: Subscription;
    dialogRef : MatDialogRef<AddToSuccessModalComponentGeneric>;
    addToCartOpenModal$: Observable<boolean>;

    constructor(protected store$: Store<any>,
                protected solrProductService: SolrProductService,
                public dialog: MatDialog,
                protected productPageService: ProductPageService_Generic,
                protected quickPadService: QuickPadService_Generic) {
        this.addToCartError$ = this.store$.select(getAddToCartError);
        this.updatedCartSuccess$ = this.store$.select(getUpdatedCartSuccess);
        this.subscriptions = new Subscription();
        this.addToCartOpenModal$ = this.store$.select(getAddToCartOpenModal);

    }

    ngOnInit() {
        this.addToCartOpenModal$.subscribe(open => {
            if(open && this.openModalSub) {
                this.openModalSub.unsubscribe();
            }
        });
        if(!this.product && this.productId && this.fixedLotMultiplier) {
            this.productId = Number(this.productId);
            this.fixedLotMultiplier = Number(this.fixedLotMultiplier);

            this.product = new ProductFullSolrDTO({
                'product_id_i': this.productId,
                'fixed_lot_multiplier_i': this.fixedLotMultiplier,
            });
        }
    }


    ngOnChanges(changes: SimpleChanges) {
        if (changes.product && changes.product.currentValue.product_id_i && changes.product.currentValue.product_id_i !== -1) {
            this.quantity = this.product.fixed_lot_multiplier_i || 0;
            this.quantityChange.emit(this.quantity);
        }
    }


    updateQty(data) {
        this.quantity = data.qty;
        this.quantityChange.emit(this.quantity);
    }

    confirmAddToCart() {
        const action = CartActions.addToCart([this.data], {afterRemoveAll: false});
        this.openModalSub = this.addToCartError$.subscribe(error => {
            if (error) {
                this.openAddToCartErrorDialog(error);
            } else {
                if (this.openModalSub) this.openModalSub.unsubscribe();
            }
        });

        this.store$.dispatch(action);
    }

    openAddToCartErrorDialog(error) {
        const initialState = {
            title: error['error'] ? error['error'] : error,
            redirectText: 'Empty and Continue',
            continueText: 'Cancel'
        };
        this.dialogRef = this.dialog.open(
            AddToSuccessModalComponentGeneric,
            {data: initialState, maxWidth: 'none', maxHeight: 'none', panelClass: 'add-product-dialog'});
        this.dialogRef.afterClosed().subscribe(dialogResult => {
            if (dialogResult) {
                this.removeAllItems();
            }
        });
        this.closeModal();
    }

    addToCart() {
        this.data = {
            product_id: this.product.product_id_i,
            quantity: this.quantity
        };
        if(this.addToQuickPad){
            this.quickPadService.itemToAdd$.next({
                            product_id: this.product.product_id_i,
                            quantity: this.quantity,
                            productQtyInStock: +this.qtyInStock,
                            sku: this.productSku
                        })
        } else {
            this.confirmAddToCart()
        }
    }

    closeModal() {
        const action = CartActions.addToCartCloseFailure();
        this.store$.dispatch(action);
    }

    removeAllItems() {
        const actionRemoveAllItems = CartActions.removeAllItems();
        this.store$.dispatch(actionRemoveAllItems);
        this.updatedCartSuccess$.subscribe(isUpdate => {
            if (isUpdate) {
                const action = CartActions.addToCart([this.data], {afterRemoveAll: true});
                this.store$.dispatch(action);
            }
        });
    }
}
